var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473_9465)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.1277,
    cy: 48.8736,
    r: 37.6236,
    fill: "#FB0000",
    fillOpacity: 0.63,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3669 43.1539C54.8905 40.5353 46.6876 40.7952 39.3778 43.9043L38.1882 44.3854C35.4664 45.4862 33.9313 48.3855 34.5506 51.2553L35.1305 53.9428C35.3191 54.8166 36.144 55.4016 37.0309 55.2904L43.6538 54.4607C44.6266 54.3389 45.3023 53.4318 45.1406 52.4648L44.6954 49.8027C49.0222 48.2467 53.7562 48.1612 58.1364 49.5598L57.7877 52.2362C57.661 53.2084 58.3691 54.0905 59.3456 54.1771L65.9943 54.767C66.8846 54.846 67.6877 54.2319 67.8447 53.3521L68.3312 50.6273C68.8503 47.7196 67.1891 44.8632 64.4051 43.8764L62.37 43.155L62.3669 43.1539Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473_9465",
    x: 0.754478,
    y: 0.500389,
    width: 96.7465,
    height: 96.7473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.37481
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_9465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473_9465",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/EndCall.e7f4b1c1069e57628b2efa28012a4560.svg";
export { ForwardRef as ReactComponent };